export default __webpack_public_path__ + "static/media/homeHero.d195612a.webp";